import { render, staticRenderFns } from "./ed-lesson-create-file.vue?vue&type=template&id=4ab63656&scoped=true&"
import script from "./ed-lesson-create-file.ts?vue&type=script&lang=ts&"
export * from "./ed-lesson-create-file.ts?vue&type=script&lang=ts&"
import style0 from "./ed-lesson-create-file.scss?vue&type=style&index=0&id=4ab63656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab63656",
  null
  
)

export default component.exports